module.exports = __webpack_public_path__ + "static/img/pico32.50fc8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico32.png
// module id = RyYw
// module chunks = 0